//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        props: {
            dataSource:{
                type:Array,
                default:[]
            },
            customerCss:{
                type:String,
                default:''
            },
            onItemClick:{
                type:Function,
            }
        },
        
        data(){
            return {
               count: this.dataSource.length,
               width: this.dataSource.length===0 ? "": "width:" +100/this.dataSource.length + "%",
               index: 0
            }
        },
        
        methods:{
            itemClick(index,item){
               this.index =index;
               typeof this.onItemClick ==='function' && this.onItemClick(item);
            }
        }
    }



// WEBPACK FOOTER //
// ./src/vue-components/tab/tab.vue